var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboardIcon1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 65,
    viewBox: "0 0 66 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 65,
    rx: 10,
    fill: "#F6F8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.25 34.6351L31.8215 36.3951L35.75 31.9951",
    stroke: "#5F6FFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 31.9943C22 26.8088 22 24.2161 23.6109 22.6052C24.9758 21.2403 27.0456 21.0318 30.8 21M44 31.9943C44 26.8088 44 24.2161 42.389 22.6052C41.0242 21.2403 38.9544 21.0318 35.2 21",
    stroke: "#5F6FFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8 42.9945C27.7197 42.9945 26.1796 42.9945 25.0031 42.395C23.9682 41.8678 23.1268 41.0264 22.5995 39.9915C22 38.815 22 37.2749 22 34.1945C22 31.1142 22 29.5741 22.5995 28.3976C23.1268 27.3627 23.9682 26.5213 25.0031 25.994C26.1796 25.3945 27.7197 25.3945 30.8 25.3945H35.2C38.2803 25.3945 39.8204 25.3945 40.997 25.994C42.0319 26.5213 42.8733 27.3627 43.4005 28.3976C44 29.5741 44 31.1142 44 34.1945C44 37.2749 44 38.815 43.4005 39.9915C42.8733 41.0264 42.0319 41.8678 40.997 42.395C39.8204 42.9945 38.2803 42.9945 35.2 42.9945",
    stroke: "#5F6FFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon1);
export default __webpack_public_path__ + "static/media/dashboard_icon_1.5734410392f9b733983a54bd141d8edb.svg";
export { ForwardRef as ReactComponent };